import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import ErrorScreen from "../components/ErrorScreen";
import { useUser } from "../context/UserContext";
import AlertModal from "../components/AlertModal";
import EggHierarchyTable from "../components/EggHierarchyTable";
import { useAlertModal } from "../hooks/useAlertModal";
import TransactionSummaryTable from "../components/TransactionSummaryTable";

const CoinManagement = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isMiniTabOpen, setMiniTabOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("coinManagement");

  const [loading, setLoading] = useState(true); // 로딩 상태 추가
  const [error, setError] = useState(null); // 에러 처리

  const [users, setUsers] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(0); // 페이지 번호
  const [size, setSize] = useState(10); // 페이지 크기
  const [totalPages, setTotalPages] = useState(0);

  const [agencyTree, setAgencyTree] = useState([]);
  const [amountInput, setAmountInput] = useState({});

  const [subAgencies, setSubAgencies] = useState([]);

  // 지급/회수 내역 탭
  const [txPage, setTxPage] = useState(0);
  const [txSize, setTxSize] = useState(10);
  const [txTotalPages, setTxTotalPages] = useState(0);

  const [transactionHistory, setTransactionHistory] = useState([]);

  
  // 알 이동 내역 탭
  const [mvPage, setmvPage] = useState(0);
  const [mvSize, setmvSize] = useState(10);
  const [mvTotalPages, setmvTotalPages] = useState(0);
  const [movementHistory, setMovementHistory] = useState([]);

  const [mvStartDate, setMvStartDate] = useState("");
  const [mvEndDate, setMvEndDate] = useState("");
  
  const { userInfo ,setUserInfo} = useUser();

    // ✅ 필터링 상태 추가
    const [filterUser, setFilterUser] = useState(""); // 유저 선택 필터
    const [filterType, setFilterType] = useState("전체"); // 지급/회수 필터
    const [startDate, setStartDate] = useState(""); // 시작 날짜 필터
    const [endDate, setEndDate] = useState(""); // 종료 날짜 필터

    

  const {
    isAlertOpen,
    alertMessage,
    showAlert,
    closeAlert
  } = useAlertModal();



      const handleAction = async (action, userId,type) => {
       
        const amount = amountInput[userId];
        const targetUser = users.find(u => u.id === userId && u.type === type);
        if (!amount || amount <= 0) {
          showAlert("올바른 금액을 입력하세요");
          return;
        }
      
        // 지급 시 내 알보다 많으면 거부
        if (action === "give" && amount > userInfo.egg) {
          showAlert("잔액이 부족합니다.");
          return;
        }
      
      const targetTypeMapped = ["어드민", "본사", "부본사", "대리점"].includes(type) ? "admin" : "user";
        try {
          const res = await fetch(`${API_BASE_URL}/admin/egg/${action}?` + new URLSearchParams({
            targetId: userId,
            targetType: targetTypeMapped, // "admin" or "user"
            amount,
            operatorUsername: userInfo.username
          }), {
             headers: {
           
           'X-Frontend-Request': 'true',
          },
            method: "POST",
          });
      
          if (!res.ok) {
            const msg = await res.text();
            throw new Error(msg);
          }
      
          window.location.reload(); // 또는 최신 유저 리스트 재조회
        } catch (err) {
     
          showAlert("오류: " + err.message);
        }
      };

  useEffect(() => {
    
    fetchUsers(); // 최초 로딩 시

    if(userInfo.adminType == "대리점")
      {
        setActiveTab("movementHistory");
      }
  }, [page, keyword]);

  
  useEffect(() => {
    // 하위 업체 목록을 불러오는 API 호출
    const fetchSubAgencies = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/admin/sub-agencies?parentUsername=${userInfo.username}`,{ headers: {
           
           'X-Frontend-Request': 'true',
          },});
        const data = await response.json();
        
        setSubAgencies(data);
        setLoading(false);
      } catch (error) {
        console.error("하위 업체 목록을 불러오는 데 실패했습니다.", error);
        setLoading(false);
      }
    };

    fetchSubAgencies();
  }, [userInfo.username]);

  
  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/coin/balances`, {
         headers: {
           
           'X-Frontend-Request': 'true',
          },
        params: { keyword: "" ,size:size,page:page,operatorUsername: userInfo.username},
      });
      setUsers(response.data.content || []); // 성공 시 유저 데이터 저장
      setTotalPages(response.data.totalPages); // 총 페이지 수 설정
    } catch (err) {
      setError("유저 데이터를 불러오는 데 실패했습니다.\n"+err);
    } finally {
      setLoading(false); // 항상 로딩 종료
    }
  };

  
  const fetchEggs = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/egg`, {
         headers: {
           
           'X-Frontend-Request': 'true',
          },
        params: { username: userInfo.username },
      });
      const egg = response.data.egg;

      // 기존 userInfo 유지하면서 egg만 업데이트
      setUserInfo(prev => ({ ...prev, egg }));
    } catch (err) {
      setError("유저 데이터를 불러오는 데 실패했습니다.\n"+err);
    } finally {
      setLoading(false); // 항상 로딩 종료
    }
  };

  const fetchTrees = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/agency/agency-tree`, {
         headers: {
           
           'X-Frontend-Request': 'true',
          },
        params: { username: userInfo.username },
      });
      const agencytree = response.data;

      setAgencyTree(agencytree);
    } catch (err) {
      setError("유저 데이터를 불러오는 데 실패했습니다.\n"+err);
    } finally {
      setLoading(false); // 항상 로딩 종료
    }
  };
  useEffect(() => {
    fetchEggs(); // 최초 로딩 시\
    fetchTrees();
  }, []);

  const handleChargeEgg = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/admin/charge-egg?username=${userInfo.username}`, {
         headers: {
           
           'X-Frontend-Request': 'true',
          },
        method: "POST",
      });
      if (!res.ok) throw new Error("충전에 실패했습니다.");
  
      const updatedUser = await res.json();
      setUserInfo(updatedUser); // Context에 반영
     
    } catch (err) {
      console.error("알 충전 오류:", err);
      
    }
  };

  const fetchTransactionHistory = async () => {
   

    try {   
      const response = await axios.get(`${API_BASE_URL}/transactions`, {
         headers: {
           
           'X-Frontend-Request': 'true',
          },
        params: {
          page: txPage,
          size: txSize,
          selectedUser: userInfo.username,
          username: filterUser,
          type: filterType !== "전체" ? filterType : null,
          start:startDate,
          end:endDate
        },
      });
      setTransactionHistory(response.data.content || []);
     
      setTxTotalPages(response.data.totalPages || 0);
    } catch (err) {
      console.log(err);
      setError("거래 내역을 불러오는 데 실패했습니다.");
    }
  };

  useEffect(() => {
    fetchTransactionHistory();
  }, [txPage, txSize,filterUser,filterType,startDate,endDate]);


  const handleSearch = (e) => {
    setKeyword(e.target.value);
    setPage(0); // 검색 시 페이지 리셋
  };


  const fetchMovementHistory = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/movements`, {
         headers: {
           
           'X-Frontend-Request': 'true',
          },
          
         params: {
          page: mvPage,
          size: mvSize,
          selectedUser: userInfo.username,
          startDate: mvStartDate,
          endDate: mvEndDate,
        },
      });
  
      const movements = response.data.content || [];
  
      // 유저 정보 기준으로 sender/receiver 권한 붙이기
      const enhancedMovements = movements.map((move) => {
        const senderName =
        move.senderUser?.username ||
        move.senderAdmin?.username ||
        "알 수 없음";
      const receiverName =
        move.receiverUser?.username ||
        move.receiverAdmin?.username ||
        "알 수 없음";
    
      // 역할 찾기
      const senderRole = move.senderRole;
      const receiverRole =  move.receiverRole;

      return {
        ...move,
        sender: senderName,
        receiver: receiverName,
        senderRole: senderRole,
        receiverRole: receiverRole,
        };
      });
  
      setMovementHistory(enhancedMovements);
      
      setmvTotalPages(response.data.totalPages || 0);
    } catch (err) {
      setError("알 이동 내역을 불러오는 데 실패했습니다." + err);
    }
  };

  useEffect(() => {
    fetchMovementHistory().then(() => {
      //applyMovementFilter(); // 데이터 fetch 후 수동 적용
    });
  }, [mvPage, mvSize,mvStartDate,mvEndDate]);

  // ✅ 미니탭 열기
  const openMiniTab = (user) => {
    setSelectedUser(user);
    setMiniTabOpen(true);
    document.body.style.overflow = "hidden"; // 스크롤 방지
  };

  // ✅ 미니탭 닫기
  const closeMiniTab = () => {
    setMiniTabOpen(false);
    setSelectedUser(null);
    document.body.style.overflow = "auto"; // 스크롤 원래대로
  };

  // ✅ ESC 키 입력 시 미니탭 닫기
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && isMiniTabOpen) {
        closeMiniTab();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isMiniTabOpen]);

  

  if (loading) {
    
    return (
      <div className="loading-overlay">
        <div className="loader"></div>
      </div>
    );
  }
  
  if (error) {
    return <ErrorScreen message={error} />;
  }

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const yy = String(date.getFullYear()).slice(2); // '25'
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // '05'
    const dd = String(date.getDate()).padStart(2, '0'); // '09'
    const hh = String(date.getHours()).padStart(2, '0'); // '14'
    const min = String(date.getMinutes()).padStart(2, '0'); // '23'
    return `${yy}.${mm}.${dd} ${hh}:${min}`;
  };

  return (
    <div className="container-inner">
      {/* ✅ 상단 탭 메뉴 */}
     
   
      {userInfo.adminType != "대리점" && (<>
        <div className="tab-menu">
            <button className={activeTab === "coinManagement" ? "active" : ""} onClick={() => setActiveTab("coinManagement")}>
          알 화폐 관리
        </button>
      <button className={activeTab === "transactionHistory" ? "active" : ""} onClick={() => setActiveTab("transactionHistory")}>
      지급/회수 내역
    </button>
    
    <button className={activeTab === "movementHistory" ? "active" : ""} onClick={() => setActiveTab("movementHistory")}>
          알 이동 내역
        </button>
        </div>
    </>
      ) }

        

      {activeTab === "coinManagement" && (
      <>
        <div className="currency-header">
          <h2>알 화폐 관리</h2>

          <div className="currency-info">
            <span>현재 알: <strong>{userInfo.egg}</strong></span>
            {userInfo.adminType === "어드민" && (
                    <button className="btn-primary btn-charge" onClick={handleChargeEgg}>
                      알 충전
                    </button>
                  )}
          </div>
        </div>
        
         {agencyTree.length > 0 ?<>
        <EggHierarchyTable agencyTree={agencyTree} handleAction={handleAction} amountInput ={amountInput} setAmountInput={setAmountInput} />
          </>: <div className="empty-state">
        <i className="fa-solid fa-exclamation-circle"></i>
        <p className="title">내역이 존재하지 않습니다</p>
      </div>
          }
  </>
)}

{/* ✅ 지급/회수 내역 */}
{activeTab === "transactionHistory" && (
  <div className="history-list">
    <h2>지급/회수 내역</h2>

    {/* ✅ 필터 영역 */}
    <div className="filters">
    {
      <select value={filterUser} onChange={(e) => setFilterUser(e.target.value)}>
        <option value="">전체 유저</option>
        {subAgencies.map((user) => (
          <option key={"user_id"+user.id} value={user.username}>{user.username}</option>
        ))}
      </select>
        } 
   
      <input type="datetime-local" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
      <input type="datetime-local" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
        <option value="전체">전체</option>
        <option value="지급">지급</option>
        <option value="수령">수령</option>
        <option value="회수">회수</option>
      </select>

    </div>

    {/* ✅ 필터링된 지급/회수 내역 */}
    <table>
      <thead>
        <tr>
          <th>번호</th>
          <th>ID</th>
          <th>종류</th>
          <th>이전 보유 알</th>
          <th>변동 알</th>
          <th>이후 보유 알</th>
          <th>사용 일시</th>
          <th>메모</th>
        </tr>
      </thead>
      <tbody>
       
      {transactionHistory.length > 0 ? ( <>{transactionHistory
          .filter((tx) => (filterType !== "전체" ? tx.type === filterType : true))
          .map((tx) => {
            const userInfo = users.find((user) => user.username === tx.user) || { role: "알 수 없음" };

            return (
              <tr key={"log_"+tx.id}>
                <td>{tx.id}</td>
                <td>{tx.username}</td>
                <td>{tx.type}</td>
                <td>{tx.examount}</td>
                <td>{tx.amount}</td>
                <td>{tx.changedamount}</td>
                <td>{formatDate(tx.date)}</td>
                
                <td>{tx.memo}</td>
              </tr>
            );
          })}</>
        ):<></>}

      </tbody>
    </table>
    {transactionHistory.length > 0 ? ( <></> ): (
    
      <div className="empty-state">
        <i className="fa-solid fa-exclamation-circle"></i>
        <p className="title">내역이 존재하지 않습니다</p>
      </div>
  )}
    {/* ✅ 지급/회수 총 집계 */}
    
    
   
    
    {transactionHistory.length > 0 ? (<>
    <div className="pagination">
    <button
              disabled={txPage === 0}
              onClick={() => setTxPage(txPage - 1)}
            >
              ◀
            </button>
      {Array.from({ length: txTotalPages }, (_, i) => (

        <button
          key={"tx_page"+i}
          className={txPage === i ? "active" : ""}
          onClick={() => setTxPage(i)}
        >

          {i + 1}
        </button>

        
      ))}
        <button
              disabled={txPage === txTotalPages - 1}
              onClick={() => setTxPage(txPage + 1)}
            >
              ▶
            </button>
    </div>
      <TransactionSummaryTable
      username = {userInfo.username}
      filterUser={filterUser}
      start= {startDate ? new Date(startDate) : null}
      end= {endDate ? new Date(endDate) : null}
    />
        </>
  
    
  ):<></>
    }
  </div>
  

)}
 



{/* ✅ 알 이동 내역 */}
{activeTab === "movementHistory" && (
  <div className="history-list">
    <h2>알 이동 내역</h2>

    {/* ✅ 필터 UI */}
    <div className="filters">

      <input type="datetime-local" value={mvStartDate} onChange={(e) => setMvStartDate(e.target.value)} />
      <input type="datetime-local" value={mvEndDate} onChange={(e) => setMvEndDate(e.target.value)} />

    </div>

    {/* ✅ 알 이동 내역 테이블 */}
    <table>
      <thead>
        <tr>
          <th>보낸 유저</th>
          <th>보낸 유저 권한</th>
          <th>받은 유저</th>
          <th>받은 유저 권한</th>
          <th>금액</th>
          <th>이동 타입</th>
          <th>날짜</th>
        </tr>
      </thead>
      <tbody>
      {movementHistory.length > 0 ? ( <>{movementHistory.filter((mv) => (filterUser ? mv.user === filterUser : true))
          .filter((mv) => (filterType !== "전체" ? mv.type === filterType : true)).map((move) => {

          return (
            <tr key={"move_user"+move.id}>
              <td>{move.senderUsername==null?"시스템":move.senderUsername}</td>
              <td>{move.senderRole=="없음"?"시스템":move.senderRole}</td>
              <td>{move.receiverUsername?move.receiverUsername:move.receiverAdminname}</td>
              <td>{move.receiverRole}</td>
              <td>{move.amount} 알</td>
              <td>{move.type} </td>
              <td>{move.createdAt.substring(0, 19).replace('T', ' ')}</td>
            </tr>
          );
        })}</>):<></>}
      </tbody>
    </table>

            {movementHistory.length > 0 ? ( <>
              <div className="pagination">
                {/* 이전 페이지 버튼 */}
                <button disabled={mvPage === 0} onClick={() => setmvPage(mvPage - 1)}>
                  ◁
                </button>

                {mvTotalPages > 0 && (
                  <>
                    {/* 현재 페이지 기준 ±2 페이지 범위 계산 */}
                    {Array.from({ length: mvTotalPages }, (_, i) => i)
                      .filter(i => {
                        // 페이지 범위 조정: 항상 5개의 버튼을 보여주기
                        if (mvPage <= 2) return i <= 4; // 첫 페이지일 때, 1~5
                        if (mvPage >= mvTotalPages - 3) return i >= mvTotalPages - 5; // 마지막 페이지일 때, 마지막 5개
                        return i >= mvPage - 2 && i <= mvPage + 2; // 그 외에는 ±2 페이지
                      })
                      .map(i => (
                        <button
                          key={i}
                          className={i === mvPage ? "active" : ""}
                          onClick={() => setmvPage(i)}
                        >
                          {i + 1}
                        </button>
                      ))}
                  </>
                )}

                {/* 다음 페이지 버튼 */}
                <button disabled={mvPage === mvTotalPages - 1} onClick={() => setmvPage(mvPage + 1)}>
                  ▷
                </button>
              </div>
        </>): (
            
            <div className="empty-state">
              <i className="fa-solid fa-exclamation-circle"></i>
              <p className="title">내역이 존재하지 않습니다</p>
            </div>
        )}
                
        </div> 

  
)}

      {/* ✅ 배경 오버레이 */}
      {isMiniTabOpen && <div className="overlay" onClick={closeMiniTab}></div>}

      {/* ✅ 미니탭 UI (알 지급 & 알 회수 버튼 추가) */}
      {isMiniTabOpen && selectedUser && (
        <div className="mini-tab">
          <div className="mini-tab-content">
            <h3>현재 보유 알</h3>
            <p className="current-al"><strong>{selectedUser.balance}</strong> 알</p>

            <h4>유저 정보</h4>
            <p><strong>닉네임:</strong> {selectedUser.name}</p>
            <p><strong>권한 등급:</strong> {selectedUser.role}</p>
            <p><strong>보유 알:</strong> {selectedUser.balance} 알</p>

            <div className="input-group">
              <label htmlFor="alAmount">금액 입력:</label>
              <input type="number" id="alAmount" placeholder="숫자 입력" />
            </div>

            {/* ✅ 알 지급 & 알 회수 버튼 */}
            <div className="btn-group">
              <button className="btn-primary btn-give-al">알 지급</button>
              <button className="btn-danger btn-take-al">알 회수</button>
            </div>

            <button className="btn-primary-outline" onClick={closeMiniTab}>닫기</button>
          </div>
        </div>

      )}

      {isAlertOpen && <AlertModal message={alertMessage} onClose={closeAlert} />}

    </div>

    
  );
};

export default CoinManagement;